import styled from "styled-components";

import * as Table from "ds/Table";
import { breakpoints } from "Libs/theme";

export const EmptyList = styled.div`
  margin-bottom: 16px;
  padding: 24px 32px;
  border-radius: 4px;
  background-color: var(--mode-bg-neutral-weakest);
  text-align: center;
`;

export const TableThead = styled(Table.Thead)`
  padding-right: 24px;
  gap: 16px;
`;

export const SpacerTableTh = styled(Table.Th)`
  display: none;

  @media (min-width: ${breakpoints[2]}) {
    display: flex;
  }
`;
